import { c as _c } from "react/compiler-runtime";
import type { MergeabilityStatus } from '@/lib/hooks/mergeability-status/get-mergeability-status.server';
import { Check, X } from 'lucide-react';
type ConflictSectionProps = {
  mergeabilityStatus?: MergeabilityStatus;
};
export function ConflictSection(t0) {
  const $ = _c(2);
  const {
    mergeabilityStatus
  } = t0;
  if (!mergeabilityStatus?.mergeConflicts.passed) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="flex cursor-default items-center justify-between focus:bg-zinc-700 py-2"><div className="flex items-center gap-2"><X className="size-4 -translate-y-px stroke-red-500" />Branch has conflicts with the base branch</div></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center justify-between focus:bg-zinc-700 py-2"><div className="flex items-end gap-2"><Check className="size-4 -translate-y-px stroke-zinc-500" />No merge conflicts</div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}